/** Avatar initials for the topbar (prototype v108 P 61): "Traci Brown" → "TB"; an email → its first letter. */
export function initials(name) {
  const parts = String(name || '').replace(/@.*/, '').split(/[\s._-]+/).filter(Boolean)
  return ((parts[0]?.[0] || '') + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase() || '?'
}
